/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed, set } from '@ember/object';

import FilterConstants from '../../../filter-constants';

export default class BigHugeCircuitGroup extends EmberObject {
  circuit = null;
  toleranceInput = null;
  reverseImplementation = null;
  @computed('circuit.opAmp.gbw', 'toleranceInput') get gbwArray() {
    var toleranceInput = this.toleranceInput;
    var gbw = toleranceInput.opAmpGbwTolerance;
    var opAmpGbw = this.circuit.opAmp.gbw;
    var result = [opAmpGbw];
    if (gbw === FilterConstants.gbwTolerance.twenty) {
      result = [opAmpGbw * 0.8, opAmpGbw, opAmpGbw * 1.2];
    }

    return result;
  }

  @computed('circuit', 'reverseImplementation') get nominalValues() {
    var circuit = this.circuit;
    var result = this.reverseImplementation.execute(circuit);
    return result;
  }

  @computed('circuits') get magnitude() {
    var circuits = this.circuits;
    var result = circuits.map((circuit) => {
      return circuit.magnitude;
    });

    return result;
  }

  @computed('circuits') get phase() {
    var circuits = this.circuits;
    var result = circuits.map((circuit) => {
      return circuit.phase;
    });

    return result;
  }

  @computed('circuit.inputImpedanceMagnitude') get inputImpedanceMagnitude() {
    var result = this.circuit.inputImpedanceMagnitude;
    return result;
  }

  @computed('circuit.inputImpedancePhase') get inputImpedancePhase() {
    var result = this.circuit.inputImpedancePhase;
    return result;
  }

  setNormalizers(bigHugeCircuitArray) {
    var result = bigHugeCircuitArray;
    var absRealPartArray = result.map((item) => {
      return Math.abs(item.absoluteRealPart);
    });
    var absImaginaryPartArray = result.map((item) => {
      return Math.abs(item.absoluteImaginaryPart);
    });
    var maximumRealPart = Math.max.apply(Math, absRealPartArray);
    var maximumImaginaryPart = Math.max.apply(Math, absImaginaryPartArray);

    result.forEach((element) => {
      set(element, 'realPartNormalizer', maximumRealPart);
      set(element, 'imaginaryPartNormalizer', maximumImaginaryPart);
    });

    return result;
  }
}
